(ns ui.page-components.filter-bar.view
  (:require
   [common.localization :as loc]
   [re-frame.core :as rf]
   [ui.components.filter.view :as filter]
   [ui.components.popover-filter.view :as popover-filter]
   [ui.page-components.filter-bar.event :as event]
   [ui.page-components.filter-bar.sub :as sub]))

(defn view
  [{:keys [component-id all-filters init-filters]}]
  (let []
    ;; TODO: we should not probably dispatch init here
    (rf/dispatch [::event/init component-id all-filters init-filters])
    (fn [{:keys [component-id]}]
      (let [filters @(rf/subscribe [::sub/filter-configs component-id])
            filter-options @(rf/subscribe [::sub/add-filter-options component-id])
            default-filter @(rf/subscribe [::sub/default-filter component-id])
            new-filter-index @(rf/subscribe [::sub/newly-added-filter component-id])]
        [:div
         {:class "mb-1 flex gap-2 flex-wrap [&>div>button]:p-0"}
         (->> filters
              (map-indexed (fn [idx {:keys [] :as filter}]
                             ^{:key (str "test-filter-" component-id "-" idx)}
                             [popover-filter/view
                              {:field-options      filter-options
                               :filter             filter
                               :start-open?        (= idx new-filter-index)
                               :placeholder        (loc/tr :select-field)
                               :on-field-change    #(rf/dispatch [::event/change-filter-field component-id idx %])
                               :on-operator-change #(rf/dispatch [::event/change-filter-operator component-id idx %])
                               :on-value-change    #(rf/dispatch [::event/change-filter-value component-id idx %])
                               :trigger-button     [filter/view (assoc filter
                                                                       :on-delete
                                                                       #(rf/dispatch [::event/delete-filter component-id idx]))]}]))
              (doall))
         [:button
          {:class "m-0 p-2 py-1.5
                   text-sm text-base-light-text leading-3
                   border border-solid border-base-light-border-paler hover:border-base-light-border
                   rounded-full"
           :on-click #(rf/dispatch [::event/add-filter component-id default-filter])}
          [:span
           (loc/tr :add-filter)]]]))))
